module.exports = __webpack_public_path__ + "static/media/man_rounded_2.0c633428.png";